import { StyleSheet } from 'aphrodite';
import { brandPrimary, white } from '../../../styles/colors';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	clear: {
		color: brandPrimary,
		marginLeft: 10,
	},
	dateSelect: {
		borderRadius: 6,
		flex: 1,
		marginLeft: 10,
		marginRight: 10,
		minWidth: 0,
	},
	header: {
		alignItems: 'center',
		background: white,
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		padding: `${THEME.spacing.sm}px 0`,
		gap: THEME.spacing.sm,
	},
	headerSearchWrap: {
		display: 'flex',
		width: '100%',
	},
	searchContainer: {
		display: 'flex',
		flex: '1 1 620px',
		justifyContent: 'space-between',
		minWidth: 0,
	},
	searchField: {
		flex: 1,
		minWidth: 0,
	},
	searchLeft: {
		flex: '1 1 260px',
		minWidth: 0,
	},
	sortSelect: {
		borderRadius: 6,
		flex: 2,
		minWidth: 0,
	},
});
